import { AppState } from '../../types';
import { BehaviorSignalElementBlock, KeepRuleSetWithId } from './types';
import {
  BehaviorSignalElementBlock as RecordingBehaviorSignalElementBlock,
  BehaviorSignalType,
} from '@fullstory/proto/fs/services/ingestion-settings';
import { createSelector } from 'reselect';
import { getNamedElementsById } from '../namedElements/selectors';

export const getRecordingFeatures = (state: AppState) =>
  state.ingestionSettings.recordingFeatures.data;

const getElementBlocks = (state: AppState): RecordingBehaviorSignalElementBlock[] =>
  state.ingestionSettings.behaviorSignalSettings.data?.elementBlocks ?? [];

export const getBehaviorSignalElementBlocks = createSelector(
  getElementBlocks,
  getNamedElementsById,
  (elementBlocks, namedElementsById): BehaviorSignalElementBlock[] =>
    elementBlocks.map(elementBlock => {
      if (elementBlock.namedElementId) {
        const namedElement = namedElementsById.get(elementBlock.namedElementId);
        return {
          namedElementId: elementBlock.namedElementId,
          name: namedElement?.namedElement?.name ?? '',
          selectors: namedElement?.namedElement?.platformSelectors.map(ps => ps.selector) ?? [],
          notes: namedElement?.namedElement?.description ?? '',
          signals: elementBlock.signals,
        };
      } else {
        return {
          namedElementId: '',
          name: '', // old style doesn't have names
          selectors: [elementBlock.selector],
          notes: elementBlock.notes,
          signals: elementBlock.signals,
        };
      }
    }),
);

export const getNamedElementBlockedSignals = createSelector(getElementBlocks, elementBlocks => {
  const elementMap: Map<string, BehaviorSignalType[]> = new Map();
  elementBlocks.forEach(eb => {
    if (eb.namedElementId) {
      elementMap.set(eb.namedElementId, eb.signals.sort());
    }
  });
  return elementMap;
});

export const getIsBehaviorSignalSettingsLoading = (state: AppState): boolean =>
  state.ingestionSettings.behaviorSignalSettings.loading;

export const getAreKeepRulesLoading = (state: AppState): boolean =>
  state.ingestionSettings.keepRules.loading;

export const getKeepRules = (state: AppState): KeepRuleSetWithId | null =>
  state.ingestionSettings.keepRules.data;

export const getDetectionsConfigRules = (state: AppState) =>
  state.ingestionSettings.detectionsConfigRules;
